import {DELIVERY_TYPE_IDS} from '@stubhub/delivery-utils';

/**
 * Determines the delivery highlight value based on delivery type list and expected in-hand date
 * @param {number[]} deliveryTypeList - Array of delivery type IDs
 * @param {string} expectedInhandDate - Expected in-hand date in YYYY-MM-DD format or ISO timestamp
 * @returns {string|null} - The delivery highlight value or null if no highlight applies
 */
export const getDeliveryHighlight = (deliveryTypeList = [], expectedInhandDate = '') => {
  if (
    deliveryTypeList.includes(DELIVERY_TYPE_IDS.ELECTRONIC_INSTANT_DOWNLOAD) ||
    deliveryTypeList.includes(DELIVERY_TYPE_IDS.MOBILE_TICKET_INSTANT)
  ) {
    return 'instant';
  }

  const dateOnly = expectedInhandDate.includes('T') ? expectedInhandDate.split('T')[0] : expectedInhandDate;

  if (
    (deliveryTypeList.includes(DELIVERY_TYPE_IDS.MOBILE_TICKET) ||
      deliveryTypeList.includes(DELIVERY_TYPE_IDS.MOBILE_TRANSFER)) &&
    isToday(dateOnly)
  ) {
    return 'today';
  }

  if (isTodayOrBefore(dateOnly)) {
    return 'lax-today';
  }

  return null;
};

/**
 * Formats a Date object to YYYY-MM-DD string format
 * @param {Date} date - Date object to format
 * @returns {string} - Date string in YYYY-MM-DD format
 */
const formatDateToString = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
    2,
    '0'
  )}`;
};

/**
 * Checks if the given date is today
 * @param {string} dateString - Date string in YYYY-MM-DD format
 * @returns {boolean} - True if the date is today
 */
const isToday = (dateString) => {
  if (!dateString) {
    return false;
  }

  const todayString = formatDateToString(new Date());

  return dateString === todayString;
};

/**
 * Checks if the given date is today or before today
 * @param {string} dateString - Date string in YYYY-MM-DD format
 * @returns {boolean} - True if the date is today or before today
 */
const isTodayOrBefore = (dateString) => {
  if (!dateString) {
    return false;
  }

  const todayString = formatDateToString(new Date());

  return dateString <= todayString;
};
